import {isMobile} from "react-device-detect";

const device = {
  isMobile
}

export default device;
